// Lib
import gql from 'graphql-tag';

/* Org messaging (S1–S3). Written by hand: the schema isn't deployed yet, so
 * these aren't in src/types/graphql.ts — local types live in
 * @modules/Inbox/types. */

export const THREAD_COUNTERPART_FIELDS = `
  kind
  organizationId
  name
  email
  avatarUrl
  organizationType
  counterpartKey
  profileUrl
`;

export const THREAD_FIELDS = `
  _id
  subject
  authId
  externalEmail
  externalName
  counterpart {
    ${THREAD_COUNTERPART_FIELDS}
  }
  participants {
    kind
    organizationId
    name
    email
    avatarUrl
    organizationType
  }
  context {
    campaignId
    campaignName
    campaignAuthTaskId
    propertyId
    propertyName
    authId
  }
  blockedByMe
  lastMessageAt
  lastMessagePreview
  createdAt
  seq
  unreadCount
`;

export const THREAD_MESSAGE_FIELDS = `
  _id
  threadId
  seq
  direction
  source
  body
  authorAccountId
  authorName
  deliveryStatus
  deliveryError
  createdAt
`;

export const threadsQuery = gql`
  query Threads($input: ListThreadsInput!) {
    threads(input: $input) {
      total
      hasMore
      cursor
      items {
        ${THREAD_FIELDS}
      }
    }
  }
`;

export const threadQuery = gql`
  query Thread($id: ID!) {
    thread(id: $id) {
      ${THREAD_FIELDS}
    }
  }
`;

export const threadMessagesQuery = gql`
  query ThreadMessages($threadId: ID!) {
    threadMessages(threadId: $threadId) {
      ${THREAD_MESSAGE_FIELDS}
    }
  }
`;

/** Threads with unread messages for the current account (sidebar badge). */
export const unreadThreadsCountQuery = gql`
  query UnreadThreadsCount {
    unreadThreadsCount
  }
`;

/** The left pane (S3): one row per counterpart, newest activity first. */
export const threadCounterpartsQuery = gql`
  query ThreadCounterparts($input: ListThreadsInput!) {
    threadCounterparts(input: $input) {
      total
      items {
        counterpart {
          ${THREAD_COUNTERPART_FIELDS}
        }
        threadCount
        unreadCount
        lastMessageAt
        latestThread {
          ${THREAD_FIELDS}
        }
      }
    }
  }
`;

/** Email outreach health of the current org (paused banner). */
export const organizationOutreachHealthQuery = gql`
  query OrganizationOutreachHealth {
    organizationOutreachHealth {
      sent7d
      bounced7d
      complained7d
      pausedAt
      pausedReason
    }
  }
`;
